export default __webpack_public_path__ + "static/emiljan-48253f69f47c9d99beeb5aa8575f7e4c.jpg";